/**
 * Helper to check if a guided tour should be shown to a user
 * @param tourId Unique identifier for the tour
 * @returns Boolean indicating if the tour should be shown
 */
export function shouldShowTour(tourId): boolean {
    // Check if tour has been completed before
    const completedTours = JSON.parse(localStorage.getItem("completedTours") || "[]");
    return !completedTours.includes(tourId);
}

/**
 * Helper to mark a tour as completed
 * @param tourId Unique identifier for the tour
 */
export function markTourAsCompleted(tourId): void {
    const completedTours = JSON.parse(localStorage.getItem("completedTours") || "[]");
    if (!completedTours.includes(tourId)) {
        completedTours.push(tourId);
        localStorage.setItem("completedTours", JSON.stringify(completedTours));
    }
}

/**
 * Helper to reset a tour (mark it as not completed)
 * @param tourId Unique identifier for the tour
 */
export function resetTour(tourId): void {
    const completedTours = JSON.parse(localStorage.getItem("completedTours") || "[]");
    const updatedTours = completedTours.filter((id: string) => id !== tourId);
    localStorage.setItem("completedTours", JSON.stringify(updatedTours));
}
